import { buildAccountPath, buildContextPath } from './requestedContext';

/**
 * Builds an app switcher link for targets that accept context as query
 * parameters (the Agent Workbench). A value that is not known is omitted
 * entirely rather than sent empty, and a link with no context at all is
 * returned unchanged.
 */
export function buildQueryContextUrl(
  baseUrl: string,
  accountId?: string | null,
  workspaceId?: string | null
): string {
  if (!accountId && !workspaceId) return baseUrl;

  const url = new URL(baseUrl);
  if (accountId) url.searchParams.set('accountId', accountId);
  if (workspaceId) url.searchParams.set('workspaceId', workspaceId);
  return url.toString();
}

/**
 * Builds an app switcher link to the Artstash DAM.
 *
 * The DAM ignores `?workspaceId=` and falls through to AI search, so context
 * must travel in its path form instead: `/account/:accountId/workspaces/:workspaceId`.
 * Without an account there is no path to build, so the bare base URL is returned.
 */
export function buildDamUrl(
  baseUrl: string,
  accountId?: string | null,
  workspaceId?: string | null
): string {
  if (!accountId) return baseUrl;
  const path = workspaceId ? buildContextPath(accountId, workspaceId) : buildAccountPath(accountId);
  return `${baseUrl.replace(/\/+$/, '')}${path}`;
}
